export const errorCode = {
  UNABLE_TO_COMMUNICATE_TO_POS: {
    message:
      "Your order failed to send to the venue. Your payment has been refunded.",
    code: "UNABLE_TO_COMMUNICATE_TO_POS",
  },
};
